import { render, staticRenderFns } from "./TopProductCharts.vue?vue&type=template&id=8fdb8688"
import script from "./TopProductCharts.vue?vue&type=script&lang=js"
export * from "./TopProductCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports